const trimTrailingSlashes = (value: string): string => value.replace(/\/+$/, '');

const ensureLeadingSlash = (value: string): string => (value.startsWith('/') ? value : `/${value}`);

export const toAbsoluteUrl = (siteRoot: string, src: string | undefined): string | undefined => {
  if (!src) return undefined;
  if (src.startsWith('//') || /^https?:\/\//i.test(src)) return src;
  return `${trimTrailingSlashes(siteRoot)}${ensureLeadingSlash(src)}`;
};

export const joinUrl = (siteRoot: string, currentPath: string): string => {
  const trimmedRoot = trimTrailingSlashes(siteRoot);
  const trimmedPath = currentPath ? ensureLeadingSlash(currentPath) : '';
  return trimTrailingSlashes(`${trimmedRoot}${trimmedPath}`);
};
